<template>
  <div class="wrapper">
    <div class="content-container">
      <div class="stingy-card">
        <div style="background-color: white; padding: 20px;">
          <h2 style="color: black;">🐾 Financial Fitness with a Feline Twist! 🐾</h2>
          <div style="background-color: white; padding: 20px; border-radius: 10px;">
            <img :src="require('@/assets/cat-confetti.gif')" alt="Cat Confetti" width="250" height="250" />
            <p style="color: black;">
              Ever watched a cat decide whether to chase a laser pointer or lounge in the sun? That's like us with budgeting - there's no right or wrong, just purr-sonal preferences! 🐱💡 Whether you're a budget gym rat, always crunching those numbers, or someone who'd rather let the pros handle it, we've got you covered. 🏋️‍♂️💼
            </p>
            <p style="color: black;">
              Not a fan of crafting budgets? No worries! Just like a cat effortlessly lands on its feet, we'll elegantly craft a budget for you based on your onboarding info and transaction history. It's like having a personal financial chef who knows exactly how you like your money meals prepared. 🍽️💸
            </p>
            <p style="color: black;">
              For the budget enthusiasts (you know, the type who enjoy cold plunges after a gym session), dive into our dedicated budgeting and tracking section. It's like the financial equivalent of a high-intensity workout for your wallet! 🏊‍♂️💰
            </p>
        <h3>Why budgets are tricky, boring and not very fun?</h3>
          
          <ul>
            <li>🙀 Overwhelm: So many numbers, so little time.</li>
            <li>🤔 Guesswork: How much should you really allocate for 'Entertainment'?</li>
            <li>🎭 Lifestyle Incompatibility: Most budgets don't get you, like we cats do.</li>
            <li>💡 Sudden Expenses: Life throws curveballs and budgets get busted.</li>
          </ul>
        
  
        <h3>Why Budgets are Important:</h3>
          <ul>
            <li>💪 Financial Fitness: Just like the gym, but for your wallet.</li>
            <li>🏦 Debt Dodging: Know what you owe and strategize your escape!</li>
            <li>💰 Piggy Bank Buffing: More coins in the jar means more dreams come true.</li>
            <li>🛡️ Crisis-Proofing: Build your financial shield against life's little surprises.</li>
          </ul>
    
          <p style="color: black;">
              In the end, just like choosing a salad over fries or hitting the gym versus a yoga mat, managing your finances is all about what works best for you. Whether you're hands-on or hands-off, RiskyPaws is here to guide you to your financial nirvana. 🧘‍♀️🌟
            </p>
            <p style="color: black;">
              So, whether you’re a meticulous planner or a go-with-the-flow type, hop on the RiskyPaws express, and let's journey towards financial fitness, your way! 🚂💼🌈
            </p>
          </div>
        </div>
      </div>
    </div>
  </div><br><br><br><br><br><br>
</template>

<style scoped>

.wrapper {
display: flex;
flex-direction: column;
align-items: center;
}

.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}

.stylish-links {
background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
color: #333;
font-size: 1.4em;
margin-bottom: 15px;
}

.stylish-links ul {
list-style: none;
padding: 0;
}

.stylish-links ul li {
background-color: #fff;
margin: 10px 0;
padding: 10px;
border-radius: 8px;
box-shadow: 0 2px 4px rgba(0,0,0,0.1);
transition: all 0.3s ease;
}

.stylish-links ul li a {
color: black;
text-decoration: none;
font-weight: bold;
}

.stylish-links ul li:hover {
background-color: #4A148C;
}

.stylish-links ul li:hover a {
color: #fff;
}
</style>
  